import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  claimAuthorizedOrganizations: null,
  getClaimAuthorizedOrganizationsStatus: IDLE,
  updateClaimAuthorizedOrganizationsStatus: IDLE
};

const claimAuthorizationsSlice = createSlice({
  name: 'claimAuthorizations',
  initialState,
  reducers: {
    getClaimAuthorizedOrganizations(state) {
      state.getClaimAuthorizedOrganizationsStatus = LOADING;
    },
    getClaimAuthorizedOrganizationsSucceeded(state, action) {
      state.claimAuthorizedOrganizations = action.payload;
      state.getClaimAuthorizedOrganizationsStatus = SUCCEEDED;
    },
    getClaimAuthorizedOrganizationsFailed(state) {
      state.getClaimAuthorizedOrganizationsStatus = FAILED;
    },

    updateClaimAuthorizedOrganizations(state) {
      state.updateClaimAuthorizedOrganizationsStatus = LOADING;
    },
    updateClaimAuthorizedOrganizationsSucceeded(state) {
      state.updateClaimAuthorizedOrganizationsStatus = SUCCEEDED;
    },
    updateClaimAuthorizedOrganizationsFailed(state) {
      state.updateClaimAuthorizedOrganizationsStatus = FAILED;
    }
  }
});

export const {
  getClaimAuthorizedOrganizations,
  getClaimAuthorizedOrganizationsSucceeded,
  getClaimAuthorizedOrganizationsFailed,
  updateClaimAuthorizedOrganizations,
  updateClaimAuthorizedOrganizationsSucceeded,
  updateClaimAuthorizedOrganizationsFailed
} = claimAuthorizationsSlice.actions;

export default claimAuthorizationsSlice.reducer;
